angular.module('mtic.components.browser_popup', [])
.directive('browserPopup', function (
      $interval,
      $timeout,
      TIMING_CONSTANTS,
      EventManager,
      language
) {
  return {
    templateUrl: 'template.html',
    scope: {
    },
    link: function (scope) {
      $timeout( ()=>{
        scope.chrome_ios = window.location.href.indexOf('web-embed-connect') !== -1 || window.isWebEmbedConnect
        //window.navigator.userAgent.match("CriOS");
        }, 1000)
      scope.hideNag = true;

      scope.language = language;

      var eventManager = new EventManager('browserPopup', scope);
      eventManager.listen('login:first', function (message) {
         $timeout(()=>{
          scope.hideNag = false;
         }, 1000);
      });
      // $timeout(()=>{
      //   scope.hideNag = false;
      // }, 2500);

      scope.closeClicked = () => {
        scope.hideNag = true;
        // $timeout(()=>{
        //   scope.hideNag = true;
        //   $timeout(()=> {
        //     scope.hideNag = false;
        //   }, 120000);
        // });
      }
    }
  }
})
